import { gbp } from "../lib/format";

const bad = (v) => v === null || v === undefined || v === "" || Number.isNaN(Number(v));

export const NotSet = ({ testid }) => <span className="font-semibold text-[hsl(var(--warning))]" data-testid={testid}>Not set</span>;

const gbpM = (v) => { const m = Math.round(Number(v) / 1e4) / 100; return m === 0 ? "£0.00m" : `${m < 0 ? "−" : ""}£${Math.abs(m).toFixed(2)}m`; };
export const money = (v, compact = false) => (bad(v) ? "—" : compact ? gbpM(v) : gbp(v));

export function Money({ v, compact, required, testid }) {
  if (bad(v) || (required && Number(v) === 0)) return required ? <NotSet testid={testid} /> : <span className="text-muted-foreground">—</span>;
  return <span data-testid={testid}>{money(v, compact)}</span>;
}

// Variance cell: dir "up" = higher is good (profit, IRR); "down" = lower is good (equity, dates)
export function VarCell({ v, dir = "up", base, compact, fmt, testid }) {
  if (base !== undefined && (bad(base) || Number(base) === 0)) return <span className="text-muted-foreground" data-testid={testid}>—</span>;
  if (bad(v)) return <span className="text-muted-foreground" data-testid={testid}>—</span>;
  const n = Number(v);
  if (fmt ? n === 0 : Math.abs(n) < 1) return <span className="text-muted-foreground" data-testid={testid}>{fmt ? fmt(0) : compact ? "£0.00m" : "£0"}</span>;
  if (!fmt && compact && Math.round(Math.abs(n) / 1e4) === 0) return <span className="text-muted-foreground" title={gbp(n)} data-testid={testid}>£0.00m</span>;
  const good = dir === "up" ? n > 0 : n < 0;
  const txt = fmt ? fmt(n) : `${n > 0 ? "+" : "−"}${money(Math.abs(n), compact)}`;
  return (
    <span className={`inline-flex items-center justify-end gap-1 font-semibold ${good ? "text-[hsl(var(--positive))]" : "text-primary"}`} data-testid={testid}>
      <span aria-hidden className="text-[9px]">{n > 0 ? "▲" : "▼"}</span>{txt}
    </span>
  );
}

export const moveText = (m) => {
  const r = Math.round(Number(m));
  return r === 0 ? "On time" : `${r > 0 ? "+" : "−"}${Math.abs(r)} mo`;
};

// Timing move in months: later is bad
export function MoveCell({ m, testid }) {
  if (bad(m)) return <NotSet testid={testid} />;
  if (Math.round(Number(m)) === 0) return <span className="text-muted-foreground" data-testid={testid}>On time</span>;
  return <VarCell v={Math.round(Number(m))} dir="down" fmt={moveText} testid={testid} />;
}
